import React, {FC} from 'react';
import styled from 'styled-components';
import {palette, mediaQueryMixins, menuBreakpoint} from '../../../../../lib/styleVariables';
import {MobileHeaderMenuPrimaryItem} from '../mobileHeaderMenuPrimaryItem';
import {PrimaryLink, SecondaryLink} from '../../../../molecules/buttons';
import {HeaderMenuProps} from '../headerMenuTypes';
import {StyledRightMenuTertiaryButton, commonButtonStyle, rightMenuButtonStyle} from '.';

interface HeaderExpandMobileMenuProps {
  leftNav: HeaderMenuProps['leftNav'];
  rightNav: HeaderMenuProps['rightNav'];
  primaryItem: HeaderMenuProps['primaryItem'];
  secondaryItem: HeaderMenuProps['secondaryItem'];
  locationPath: string;
}

const StyledExpandedMobilMenu = styled.div`
  display: none;
  height: calc(100vh - 56px);
  overflow: auto;
  flex-direction: column;
  width: 100%;
  padding: 16px 16px 120px;
  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    display: flex;
  }
`;

const StyledRightMenuPrimaryButtonMobileWrapper = styled.div`
  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    background: ${palette.white.highlight};
    box-shadow: 0px -2px 14px rgba(0, 0, 0, 0.08);
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 0;
    right: 0;
    [data-theme='dark'] & {
      background: ${palette.black.highlight};
    }
  }
`;

const StyledPrimaryLink = styled(PrimaryLink)`
  ${commonButtonStyle}
  ${rightMenuButtonStyle}
`;

const StyledSecondaryLink = styled(SecondaryLink)`
  ${commonButtonStyle}
  ${rightMenuButtonStyle}
  ${mediaQueryMixins.maxWidth(`${menuBreakpoint}px`)} {
    margin-top: 16px;
  }
`;

export const HeaderExpandMobileMenu: FC<HeaderExpandMobileMenuProps> = props => (
  <StyledExpandedMobilMenu>
    {props.leftNav.map(item => (
      <MobileHeaderMenuPrimaryItem item={item} locationPath={props.locationPath} key={item.name} />
    ))}
    {props.rightNav.map(item => (
      <StyledRightMenuTertiaryButton key={item.name} href={item.href}>
        {item.name}
      </StyledRightMenuTertiaryButton>
    ))}
    <StyledRightMenuPrimaryButtonMobileWrapper>
      <StyledPrimaryLink href={props.primaryItem.href}>{props.primaryItem.name}</StyledPrimaryLink>
      <StyledSecondaryLink href={props.secondaryItem.href}>{props.secondaryItem.name}</StyledSecondaryLink>
    </StyledRightMenuPrimaryButtonMobileWrapper>
  </StyledExpandedMobilMenu>
);
